import {createSelector} from 'reselect'
import {selectTaskManagement} from '../selectors'

export const getCpPanelState = createSelector(
    selectTaskManagement,
    (tmState) => tmState.cpPanel
)

export const getCPPanelMaxWidth = createSelector(
    getCpPanelState,
    (cpPanelState) => cpPanelState.resizableMaxWidth
)

export const getCPPanelMinWidth = createSelector(
    getCpPanelState,
    (cpPanelState) => cpPanelState.resizableMinWidth
)

export const getCPPanelWidth = createSelector(
    getCpPanelState,
    (cpPanelState) => cpPanelState.width
)

export const getCollapsedCustomersSet = createSelector(
    getCpPanelState,
    (cpPanelState) => cpPanelState.collapsedCustomersSet
)

export const getCustomerIdsForExport = createSelector(
    getCpPanelState,
    (cpPanelState) => cpPanelState.visibleCustomerIds
)

export const getProjectIdsForExport = createSelector(
    getCpPanelState,
    (cpPanelState) => cpPanelState.visibleProjectIds
)

export const getIsCustomersAsc = createSelector(
    getCpPanelState,
    (cpPanelState) => cpPanelState.isCustomersAsc
)




// WEBPACK FOOTER //
// ./web/js/taskManagement/customersProjectsPanel/selectors.js